<script>
    import { t } from '../../i18n.js'
    import SuccessIcon from '../../assets/icons/SuccessIcon.svelte'
    import CopyIcon from '../../assets/icons/CopyIcon.svelte'
    export let content
    export let componentId = 'access'

    let copied = false
    
    function copyToClipboard() {
        const copyText = document.getElementById(`api-token-${componentId}`)
        navigator.clipboard.writeText(copyText.innerHTML)
        copied = true
        setTimeout(() => {
            copied = false
        }, '2000')
    }
</script>

<div class="flex mb-10">
    <div id="{`api-token-${componentId}`}" class="px-4 py-2 bg-lightest-blue rounded-l-lg max-w-md truncate">{content}</div>
    <button
        type="button"
        aria-label="{$t('general.copy-to-clipboard-aria')}"
        disabled={copied}
        on:click={copyToClipboard}
        class="{copied ? 'bg-success-green' : 'bg-light-navy hover:bg-primary-blue'} text-white transition duration-150 px-4 py-2 uppercase rounded-r-lg text-sm">
        {#if copied}
            <SuccessIcon color={'white'} />
        {:else}
            <CopyIcon color={'white'} />
        {/if}
    </button>
</div>